import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  modalHeader: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiTypography-h3': {
      marginLeft: '10px',
      maxWidth: '340px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      display: 'block',
      textOverflow: 'ellipsis'
    },
    '& .MuiTypography-h5': {
      marginLeft: '10px'
    }
  },
  warning: {
    marginLeft: '4px'
  },
  flex: {
    display: 'flex',
    alignItems: 'center'
  },
  sideInput: {
    marginLeft: '10px',
    flexGrow: '1'
  },
  inlineToggleWrapper: {
    display: 'flex',
    marginTop: '18px',
    alignItems: 'flex-start'
  },
  chip: {
    padding: '10px 18px',
    backgroundColor: palette.info.light,
    borderRadius: '2px',
    display: 'inline-block',
    '& .MuiTypography-root': {
      color: palette.info.dark
    }
  },
  footerWrapper: {
    display: 'flex',
    marginTop: '10px',
    padding: '32px 40px',
    borderTop: "1px solid ".concat(palette.shades[400]),
    justifyContent: 'flex-end',
    [breakpointsFunc.breakpoints.down('sm')]: {
      flexDirection: 'column',
      '& + &': {
        marginBottom: '10px'
      }
    }
  },
  rightButton: {
    '& + &': {
      marginLeft: '10px'
    }
  },
  form: {
    height: '100%',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'stretch'
  },
  formContent: {
    padding: '32px 40px',
    overflowY: 'auto',
    flexGrow: '1'
  }
}));
export default useStyles;